//客户列表
import { apiAxios } from "@/api/axios";
import base from "../config";
let baseURL = base.baseURL;

export default {
  //客户-客户列表-筛选项
  getClientPageFilterCols: (data) => apiAxios("post", baseURL + "/client.getClientPageFilterCols", data),
  //客户分配列表
  adminList: (data) => apiAxios("post", baseURL + "/client.allot.adminList", data),
  //客户-详情-批量调整客户订单
  adjustClientOrder: (data) => apiAxios("post", baseURL + "/client.adjustClientOrder", data),
  //客户-详情-批量调整客户配送单
  adjustClientPorder: (data) => apiAxios("post", baseURL + "/client.adjustClientPorder", data),
  //客户-详情-批量调整客户配送单
  adjustClientPorder: (data) => apiAxios("post", baseURL + "/client.adjustClientPorder", data),
  //客户-批量冻结客户
  batchFreezeClient: (data) => apiAxios("post", baseURL + "/client.batchFreezeClient", data),
  //客户-批量解冻客户
  batchUnfreezeClient: (data) => apiAxios("post", baseURL + "/client.batchUnfreezeClient", data),
  //账号-批量分配部分客户全部订单
  assignClientOrder: (data) => apiAxios("post", baseURL + "/client.assignClientOrder", data),
  //客户-批量分配部分客户全部配送单
  assignClientPorder: (data) => apiAxios("post", baseURL + "/client.assignClientPorder", data),


  //客户-客户分配-设置分配比例
  setAllotRate: (data) => apiAxios("post", baseURL + "/client.allot.setAllotRate", data),
  //组织列表
  orgList: (data) => apiAxios("post", baseURL + "/org/list", data),


  //客户 - 店铺授权
  shopManageList: (data) => apiAxios("post", baseURL + "/client.shopManageList", data),
  //客户 -店铺解除绑定
  shopAccreditCancel: (data) => apiAxios("post", baseURL + "/client.shopAccreditCancel", data),

  //客户资料
  clientList: (data) => apiAxios("post", baseURL + "/client.list", data),
  //客户-获取讲师列表
  getGkUserList: (data) => apiAxios("post", baseURL + "/client.getGkUserList", data),
  //客户-获取讲师列表
  setGkUser: (data) => apiAxios("post", baseURL + "/client.setGkUser", data),

  //客户分配
  setClientAdmins: (data) => apiAxios("post", baseURL + "/client.setClientAdmins", data),
  //客户-客户分配-采购人员列表
  allotAdminGList: (data) => apiAxios("post", baseURL + "/client.allot.allotAdminGList", data),
  //客户-客户分配-设置采购分配比例
  setGAllotRate: (data) => apiAxios("post", baseURL + "/client.allot.setGAllotRate", data),
  //客户-客户分配-配货人员列表
  allotAdminPList: (data) => apiAxios("post", baseURL + "/client.allot.allotAdminPList", data),
  //客户-客户分配-设置配货分配比例
  setPAllotRate: (data) => apiAxios("post", baseURL + "/client.allot.setPAllotRate", data),
  //客户-标记目标额
  targetAmount: (data) => apiAxios("post", baseURL + "/client.targetAmount", data),

  //客户-客户的主账号及子账号筛选
  relationAccounts: (data) => apiAxios("post", baseURL + "/client.relationAccounts", data),
  //客户-子账号设置管理员
  setChildAccountAdmin: (data) => apiAxios("post", baseURL + "/client.setChildAccountAdmin ", data),
  //客户-收件地址列表
  userAddressList: (data) => apiAxios("post", baseURL + "/client.userAddressList", data),
  //客户-地址-保存（新增/编辑）
  saveUserAddress: (data) => apiAxios("post", baseURL + "/client.address.save", data),
  //客户-地址-删除
  deleteUserAddress: (data) => apiAxios("post", baseURL + "/client.address.delete", data),
  //客户-地址-设置默认地址
  setDefaultAddress: (data) => apiAxios("post", baseURL + "/client.address.setDefault", data),
  //客户-订单列表
  orderList: (data) => apiAxios("post", baseURL + "/client.orderList", data),
  //客户-订单列表tab数据
  orderTabList: (data) => apiAxios("post", baseURL + "/client.orderTabList", data),
  //客户-客户的子账号列表
  childAccounts: (data) => apiAxios("post", baseURL + "/client.childAccounts", data),
  //客户-提出订单前预览
  orderCreatePreview: (data) => apiAxios("post", baseURL + "/client.orderCreatePreview", data),
  // 商品管理 V2-按默认售卖方案生成提出订单预览
  orderPlanPreview: (data) => apiAxios("post", baseURL + "/client.orderPlanPreview", data),
  //客户-提出订单前预览-从购物车追加
  previewAddBeCart: (data) => apiAxios("post", baseURL + "/client.previewAddBeCart", data),
  //客户-提出订单前预览-从商品库追加
  previewAddBeInventory: (data) => apiAxios("post", baseURL + "/client.previewAddBeInventory", data),
  //客户-创建新订单（临时保存&&正式提出）
  orderCreate: (data) => apiAxios("post", baseURL + "/client.orderCreate", data),
  //客户-订单余额支付数据预览
  orderPayPreview: (data) => apiAxios("post", baseURL + "/client.orderPayPreview", data),
  //客户-订单余额支付-提交支付
  orderPay: (data) => apiAxios("post", baseURL + "/client.orderPay", data),
  //客户-订单余额支付-订单支持使用的优惠券
  orderUsableDiscount: (data) => apiAxios("post", baseURL + "/client.orderUsableDiscount", data),

  //客户-配送单-配送单支付界面数据
  porderPayData: (data) => apiAxios("post", baseURL + "/client.porderPayData", data),
  //客户-配送单-余额支付配送单
  balancePayPorder: (data) => apiAxios("post", baseURL + "/client.balancePayPorder", data),
  //客户-配送单-配送单支持使用的优惠券
  porderUsableDiscount: (data) => apiAxios("post", baseURL + "/client.porderUsableDiscount", data),

  //客户-仓库导出
  warehouseInvoice: (data) => apiAxios("post", baseURL + "/client.warehouseInvoice", data),
  //客户-普通仓库列表
  stockAutoList: (data) => apiAxios("post", baseURL + "/client.stockAutoList", data),
  //客户-收费仓库列表
  stockFeeList: (data) => apiAxios("post", baseURL + "/client.stockFeeList", data),
  //客户-长存仓库箱子列表
  chargeStorageBoxList: (data) => apiAxios("post", baseURL + "/client.chargeStorageBoxList", data),
  //客户-捆包中列表
  encasementList: (data) => apiAxios("post", baseURL + "/client.encasementList", data),
  //客户-配送单-提出前预览
  porderPreview: (data) => apiAxios("post", baseURL + "/client.porderPreview", data),
  //客户-配送单-从普通仓库追加商品【提出前预览时】
  porderPreviewAddBeStockAuto: (data) => apiAxios("post", baseURL + "/client.porderPreviewAddBeStockAuto", data),
  //客户-提出订单前预览-从商品库追加(分页版)
  previewAddBeInventoryV2: (data) => apiAxios("post", baseURL + "/client.previewAddBeInventoryV2", data),
  //修改客户仓库业务回复
  serviceRemarkUpdate: (data) => apiAxios("post", baseURL + "/client.serviceRemarkUpdate", data),
  //客户-配送单-创建新配送
  porderCreate: (data) => apiAxios("post", baseURL + "/client.porderCreate", data),
  //客户-出入金明细-可选账单类型MAP
  billTypeMap: (data) => apiAxios("post", baseURL + "/client.billTypeMap", data),
  // 客户-配送单-配送单签收
  porderClientReceive: (data) => apiAxios("post", baseURL + "/client.porderClientReceive", data),
  // 客户-配送单-删除临时配送单
  porderDelete: (data) => apiAxios("post", baseURL + "/client.porderDelete", data),
  //客户-配送单-列表tab统计
  porderTabList: (data) => apiAxios("post", baseURL + "/client.porderTabList", data),
  //客户-出入金明细-可选交易方式MAP
  billMethodMap: (data) => apiAxios("post", baseURL + "/client.billMethodMap", data),
  //客户-配送单-列表
  porderList: (data) => apiAxios("post", baseURL + "/client.porderList", data),
  //客户-出入金明细
  billList: (data) => apiAxios("post", baseURL + "/client.billList", data),
  //客户-提现列表
  cashList: (data) => apiAxios("post", baseURL + "/client.cashList", data),
  //客户-商品库列表
  inventoryList: (data) => apiAxios("post", baseURL + "/client.inventoryList", data),
  //客户-商品库-清除商品缓存
  clearGoodsCache: (data) => apiAxios("post", baseURL + "/client.clearGoodsCache", data),
  // 商品库商品批量保存
  inventoryBatchSave: (data) => apiAxios("post", baseURL + "/client.inventoryBatchSave", data),
  //客户-详情-设置-发票比例
  setInvoiceRate: (data) => apiAxios("post", baseURL + "/client.setInvoiceRate", data),
  //客户-详情-设置-客户属性
  setClientAttribute: (data) => apiAxios("post", baseURL + "/client.setClientAttribute", data),
  //客户-详情-设置-客户业务采购配货
  setClientAdmins: (data) => apiAxios("post", baseURL + "/client.setClientAdmins", data),
  //客户-详情-设置-授权情况
  setAuthorized: (data) => apiAxios("post", baseURL + "/client.setAuthorized", data),
  //客户-详情-设置-客户的聊天工具
  setClientChatType: (data) => apiAxios("post", baseURL + "/client.setClientChatType", data),
  //客户-详情-设置-客户授权欠费额度
  setClientCredit: (data) => apiAxios("post", baseURL + "/client.setClientCredit", data),
  //客户-详情-设置-设置客户的售卖平台
  setClientShop: (data) => apiAxios("post", baseURL + "/client.setClientShop", data),
  //客户-详情-设置-开通付费会员
  setClientPayVip: (data) => apiAxios("post", baseURL + "/client.setClientPayVip", data),
  //客户详情
  clientDetail: (data) => apiAxios("post", baseURL + "/client.detail", data),
  //客户-详情-设置-密码重置
  resetPassword: (data) => apiAxios("post", baseURL + "/client.resetPassword", data),
  //客户-详情-设置-修改基础信息
  updateUserKeyInfo: (data) => apiAxios("post", baseURL + "/client.updateUserKeyInfo", data),
  //客户-详情-设置-修改客户真名
  updateUserRealname: (data) => apiAxios("post", baseURL + "/client.updateUserRealname", data),
  // 客户-详情-获取客户注意事项
  getNotice: (data) => apiAxios("post", baseURL + "/client.getByUserId", data),
  // 客户-详情-设置注意事项文字
  setNoticeContent: (data) => apiAxios("post", baseURL + "/client.setNoticeContent", data),
  // 客户-详情-设置客户注意事项文件
  setNoticeFile: (data) => apiAxios("post", baseURL + "/client.setNoticeFile", data),
  // 检查指定客户有没有指定类型的注意事项
  checkIfHasNotice: (data) => apiAxios("post", baseURL + "/client.checkIfHasNotice", data),
  //客户-收件地址列表(客户地址模板)
  userAddressList: (data) => apiAxios("post", baseURL + "/client.userAddressList", data),
  //客户-详情-修改业务对客户的备注
  updateYRemark: (data) => apiAxios("post", baseURL + "/client.updateYRemark", data),
  //客户-详情-获取客户临时登录密码
  getClientTempPwd: (data) => apiAxios("post", baseURL + "/client.getClientTempPwd", data),
  //客户-详情-设置发票的额外备注
  updateInvoiceRemark: (data) => apiAxios("post", baseURL + "/client.updateInvoiceRemark", data),
  //客户-详情-发票是否包含其他金额设置
  invoiceHasAmount: (data) => apiAxios("post", baseURL + "/client.invoiceHasAmount", data),
  //客户-详情-是否允许生成抽查任务
  setClientSpotTask: (data) => apiAxios("post", baseURL + "/client.setClientSpotTask", data),
  //客户-详情-是否允许添加made in china
  setMadeInChinaSwitch: (data) => apiAxios("post", baseURL + "/client.setMadeInChinaSwitch", data),
  //客户-详情-小客户手续费开关
  setSmallOrderMinFee: (data) => apiAxios("post", baseURL + "/client.setSmallOrderMinFee", data),

  //客户-仅获取商品的规格属性及不同SKU单价
  goodsAttribute: (data) => apiAxios("post", baseURL + "/client.goodsAttribute", data),

  //券列表
  getDiscount: (data) => apiAxios("post", baseURL + "/client.getDiscount", data),
  //发放券
  sendDiscount: (data) => apiAxios("post", baseURL + "/client.sendDiscount", data),
  //删除券
  deleteDiscount: (data) => apiAxios("post", baseURL + "/client.deleteDiscount", data),
  //生成券
  saveDiscount: (data) => apiAxios("post", baseURL + "/client.saveDiscount", data),
  //券汇总列表-已申请优惠券
  discountHistory: (data) => apiAxios("post", baseURL + "/client.discountHistory", data),
  //券汇总列表-免手续费开通记录
  getClientFreeByHistoryList: (data) => apiAxios("post", baseURL + "/client.getClientFreeByHistoryList", data),
  //部长生成券
  departStoreDiscount: (data) => apiAxios("post", baseURL + "/client.departStoreDiscount", data),
  //部长可用次数查询
  departUsableCount: (data) => apiAxios("post", baseURL + "/client.departUsableCount", data),

  //获取模板列表
  getDiscountGroup: (data) => apiAxios("post", baseURL + "/client.getDiscountGroup", data),
  //获取支持的模板类型
  getDiscountGroupType: (data) => apiAxios("post", baseURL + "/client.getDiscountGroupType", data),
  //删除模板
  deleteDiscountGroup: (data) => apiAxios("post", baseURL + "/client.deleteDiscountGroup", data),
  //新增/编辑模板
  saveDiscountGroup: (data) => apiAxios("post", baseURL + "/client.saveDiscountGroup", data),
  // 物流券支持的物流方式
  getDiscountLogistics: (data) => apiAxios("post", baseURL + "/client.getDiscountLogistics", data),

  //(列表和详情)手动分配
  allotAdmin: (data) => apiAxios("post", baseURL + "/client.allotAdmin", data),
  //客户详情-客户属性标识
  setAttribute: (data) => apiAxios("post", baseURL + "/client.detail.setAttribute", data),
  //设置客户唛头
  setMark: (data) => apiAxios("post", baseURL + "/client.detail.setMark", data),
  //设置客户聊天工具
  setChat: (data) => apiAxios("post", baseURL + "/client.detail.setChat", data),
  //授权设置
  setGrant: (data) => apiAxios("post", baseURL + "/client.detail.setGrant", data),
  //授权设置
  vipList: (data) => apiAxios("post", baseURL + "/client.vipList", data),
  //开通SVIP
  setClientSVIP: (data) => apiAxios("post", baseURL + "/client.setClientSVIP", data),
  //添加定时VIP开通计划
  addPlan: (data) => apiAxios("post", baseURL + "/client.vipPlan.addPlan", data),
  //客户-取消定时VIP开通计划
  cancelPlan: (data) => apiAxios("post", baseURL + "/client.vipPlan.cancelPlan", data),
  //设置-SVIP自动续费开关切换
  swithClientSvipContinue: (data) => apiAxios("post", baseURL + "/client.swithClientSvipContinue", data),

  //客户-详情-设置客户定额会员自动续费天数
  setClientAutoPayVip: (data) => apiAxios("post", baseURL + "/client.setClientAutoPayVip", data),
  //设置-银行口座
  setBankNo: (data) => apiAxios("post", baseURL + "/client.setBankNo", data),
  //设置-标准编码
  setStandardNo: (data) => apiAxios("post", baseURL + "/client.setStandardNo", data),
  //设置-法人番号
  setTaxNo: (data) => apiAxios("post", baseURL + "/client.setTaxNo", data),
  //查看问卷明细详情
  particularsDetail: (data) => apiAxios("post", baseURL + "/operate/customer/particularsDetail", data),
  //客户-详情-设置-开通按时间段免手续费
  setClientFreeByDate: (data) => apiAxios("post", baseURL + "/client.setClientFreeByDate", data),
  //客户-切换问题产品邮件开关
  switchClientProblemEmailBlock: (data) => apiAxios("post", baseURL + "/client.switchClientProblemEmailBlock", data),

  //中国国内物流列表tab数据
  chinaLogisticsTabList: (data) => apiAxios("post", baseURL + "/client.chinaLogisticsTabList", data),
  //中国国内物流列表
  chinaLogisticsList: (data) => apiAxios("post", baseURL + "/client.chinaLogisticsList", data),

  //后台充值可选支付方式列表
  payMethodList: (data) => apiAxios("post", baseURL + "/client.payMethodList", data),
  //充值-后台银行转账充值
  bankPayBalance: (data) => apiAxios("post", baseURL + "/client.bankPayBalance", data),
  //客户-邮件记录列表
  clientEmailLog: (data) => apiAxios("post", baseURL + "/client.clientEmailLog", data),
  //邮件记录详情
  clientEmailLogDetail: (data) => apiAxios("post", baseURL + "/client.clientEmailLogDetail", data),

  // 客户标签
  // 客户标签可选项
  tagList: (data) => apiAxios("post", baseURL + "/client.tag.tagList", data),
  //给客户添加标签
  addTag: (data) => apiAxios("post", baseURL + "/client.tag.addTag", data),
  // 删除客户的部分标签
  deleteTag: (data) => apiAxios("post", baseURL + "/client.tag.deleteTag", data),

  /* 运营*/
  // 修改客户备注
  updateDesc: (data) => apiAxios("post", baseURL + "/client.updateDesc", data),

  /* 客户前台账单列表*/
  // 获取账单类型&&交易方式
  getBalanceChangeTypes: (data) => apiAxios("post", baseURL + "/client.getBalanceChangeTypes", data),
  // 出入金记录
  balanceChange: (data) => apiAxios("post", baseURL + "/client.balanceChange", data),
  // 待确认入金金额
  billUnconfirmed: (data) => apiAxios("post", baseURL + "/client.billUnconfirmed", data),
  // 出入金订单配送单号展开详情
  getOrderPorderDetail: (data) => apiAxios("post", baseURL + "/client.getOrderPorderDetail", data),

  //订单标签-列表(无分页)
  orderDetailTagList: (data) => apiAxios("post", baseURL + "/config.order_detail_tag.list", data),

  //商品库商品批量保存
  favoriteInventoryBatchSave: (data) => apiAxios("post", baseURL + "/client.inventoryBatchSave", data),
  //商品标签列表
  goodsTagLogs: (data) => apiAxios("post", baseURL + "/client.goodsTagLogs", data),
  //商品历史标签-隐藏标签
  userHideTagStore: (data) => apiAxios("post", baseURL + "/client/favorite.userHideTagStore", data),
  //商品删除
  clientinventoryDelete: (data) => apiAxios("post", baseURL + "/client.inventoryDelete", data),
  // 欧美站关键词搜索商品(前台接口)
  EuropeKeywordSearchProduct: (data) => apiAxios("post", baseURL + "/client/searchFengGoods", data),

  // 第三方仓库地址
  third_party: (data) => apiAxios("post", baseURL + "/client.address.third_party", data),

  // 客户基础信息
  userBasicsInfo: (data) => apiAxios("post", baseURL + "/client.userBasicsInfo", data),
  // 统计客户历史信息
  userStats: (data) => apiAxios("post", baseURL + "/client.userStats", data),
  //消费金额图表
  disburseAmount: (data) => apiAxios("post", baseURL + "/client.disburseAmount", data),
  //订单统计
  userOrderStatistics: (data) => apiAxios("post", baseURL + "/client.userOrderStatistics", data),
  //客户订单列表
  userOrderList: (data) => apiAxios("post", baseURL + "/client.userOrderList", data),
  //客户配送单统计
  userPorderStatistics: (data) => apiAxios("post", baseURL + "/client.userPorderStatistics", data),
  //客户运输方式统计
  logisticsModeStatistics: (data) => apiAxios("post", baseURL + "/client.logisticsModeStatistics", data),
  //客户纳期占比
  naageScale: (data) => apiAxios("post", baseURL + "/client.naageScale", data),
  //客户运输重量
  transportWeight: (data) => apiAxios("post", baseURL + "/client.transportWeight", data),
  //客户配送单列表
  userPorderList: (data) => apiAxios("post", baseURL + "/client.userPorderList", data),
  //客户配送单详情
  userPorderDetail: (data) => apiAxios("post", baseURL + "/client.userPorderDetail", data),
  //客户问题产品列表
  problemProductList: (data) => apiAxios("post", baseURL + "/client.problemProductList", data),
  //客户问题产品详情
  problemProductDetail: (data) => apiAxios("post", baseURL + "/client.problemProductDetail", data),
  //客户售后统计
  afterSalesStatistics: (data) => apiAxios("post", baseURL + "/client.afterSalesStatistics", data),
  //客户售后列表
  afterSalesList: (data) => apiAxios("post", baseURL + "/client.afterSalesList", data),
  //消费比率
  consumptionRatio: (data) => apiAxios("post", baseURL + "/client.consumptionRatio", data),
  //客户动态
  customerDynamics: (data) => apiAxios("post", baseURL + "/client.customerDynamics", data),
  //客户-转寄会员档次列表
  resendVipList: (data) => apiAxios("post", baseURL + "/client.resendVipList", data),
  //客户-转寄会员设置
  setClientResendVip: (data) => apiAxios("post", baseURL + "/client.setClientResendVip", data),
  //客户-修改客户名罗马字
  updateUserNameRoma: (data) => apiAxios("post", baseURL + "/client.updateUserNameRoma", data),

  //客户-客户邮件屏蔽设置查看
  emailBlockConfig: (data) => apiAxios("post", baseURL + "/client.emailBlockConfig", data),
  //客户-集运-开启或关闭授权
  setUserCoAuth: (data) => apiAxios("post", baseURL + "/client.co.setUserCoAuth", data),
  //客户-集运-设置授权给的客户id
  setUserCoAuthUser: (data) => apiAxios("post", baseURL + "/client.co.setUserCoAuthUser", data),
  //客户-集运-查询授权给的客户列表
  getUserCoAuthUser: (data) => apiAxios("post", baseURL + "/client.co.getUserCoAuthUser", data),
  //客户-海外仓-设置客户授权海外仓
  setOverseasWarehouse: (data) => apiAxios("post", baseURL + "/client.setOverseasWarehouse ", data),
  //客户-聊天群组-修改客户聊天群组
  modifyingGroup: (data) => apiAxios("post", baseURL + "/chatWork.modifyingGroup", data),


  // 客户仓库改版
   //客户-捆包中列表V3(按订单号分)
   encasementListV3: (data) => apiAxios("post", baseURL + "/client.encasementListV3", data),
  //  后台-仓库改版-全部列表(普通仓库)
  stockAutoList: (data) => apiAxios("post", baseURL + "/client.stockAutoList", data),
  // 后台-仓库改版-仓库Tab数量
  stockTableNum: (data) => apiAxios("post", baseURL + "/client.stockTableNum", data),
  // 后台-仓库改版-散货存放列表
  stockBulkList: (data) => apiAxios("post", baseURL + "/client.stockBulkList", data),
  // 后台-仓库改版-整箱存放列表
  encasementCompletedListV3: (data) => apiAxios("post", baseURL + "/client.encasementCompletedListV3", data),
  // 后台-仓库改版-整箱存放箱子列表
  completedOrderBoxList: (data) => apiAxios("post", baseURL + "/client.completedOrderBoxList", data),
  // 后台-仓库改版-整箱自行提出配送单权限
  checkOrderBoxToPorder: (data) => apiAxios("post", baseURL + "/client.checkOrderBoxToPorder", data),
  // 后台-仓库改版-整箱勾选生成配送单
  orderBoxToPorder: (data) => apiAxios("post", baseURL + "/client.orderBoxToPorder", data),
  // 后台-仓库改版-整箱绑定材料列表
  stockMaterialBindList: (data) => apiAxios("post", baseURL + "/client.stockMaterialBindList", data),
  // 后台-仓库改版-仓库商品标记筛选选项
  stockLabelList: (data) => apiAxios("post", baseURL + "/client.stockLabelList", data),
  // 后台-仓库改版-修改单番客户备注
  updateClientRemark: (data) => apiAxios("post", baseURL + "/client.updateClientRemark", data),
  // 后台-仓库改版-修改单番仓库备注
  updateClientWmsRemark: (data) => apiAxios("post", baseURL + "/client.updateClientWmsRemark", data),
  // 后台-仓库改版-修改单番标签
  updateOrderDetailTag: (data) => apiAxios("post", baseURL + "/client.updateOrderDetailTag", data),
  // 后台-仓库改版-配送单预览国际运费试算
  porderPreviewPredictLogisticsPrice: (data) => apiAxios("post", baseURL + "/client.porderPreviewPredictLogisticsPrice", data),

};
